<template>
  <ElDialog
      v-model="isShow"
      :title="$t('customer.import.batch')"
      :footer="null"
      centered
      top="10em"
      :width="'44%'"
      style="min-width:600Cpx"
      destroyOnClose
      @cancel="cancel"
      @close="close"
      :close-on-click-modal="false"
      :class="'headline'"
  >
    <el-upload
        ref="uploadRef"
        style="width: 100%;display: flex;justify-content: center;flex-direction: column;align-items: center;margin-top: 20px"
        class="upload-demo"
        :accept="['.xls','.xlsx']"
        :auto-upload="false"
        :show-file-list="true"
        :file-list="fileList1"
        :on-change="handleUploadChange"
        :on-remove="handleRemove"
    >
      <el-button v-if="fileList1.length < 1" type="primary" plain size="large"
                 style="border: 1px dashed #409eff;width: 250px;margin: auto ">
        {{ $t('system.select.file') }}
      </el-button>
    </el-upload>
    <div style="height: 8px;width: 100%;margin-bottom: 10px;">
      <el-progress :percentage="percent" v-if="percent!==0" striped :stroke-width="10"/>
    </div>
    <div style="display: flex;margin-top: 4px">
      <el-button plain size="large" style="border: 1px dashed #dddfe5;width: 250px;margin: auto " :icon="Download"
                 @click="downloadExcel" :loading="downloadFile">
        {{ $t('list.customer.download.template') }}
      </el-button>
    </div>
    <div class="import_message" v-show="isShowData" style="color:red">
      <span>{{ $t('import.txt.1') }} <strong>{{ importCustomerMessage?.totalCount }}</strong> {{
          $t('pagination.tiao')
        }}</span>{{ $t('import.txt.2') }}
      <span>{{ $t('common.import') }}{{ $t('0') }} <strong>{{
          importCustomerMessage?.successCount
        }}</strong> {{ $t('pagination.tiao') }}</span>，
      <span>{{ $t('common.failed.send') }} <strong>{{
          importCustomerMessage?.failCount
        }}</strong> {{ $t('pagination.tiao') }}</span>
      <el-button
          link
          type="primary"
          class="import-detail-btn"
          @click="openImportDetailDialog"
      >
        {{ $t('common.view.detail') }}
      </el-button>
    </div>
    <div class="import_message" style="color: #c8453f;font-weight: 500" v-show="isErrorExcel">
      {{ $t('common.import.excel.error') }}
    </div>
    <div style="width: 100%;display: flex;justify-content: center;margin-top: 20px;margin-bottom: 20px">
      <div style="width: 85%" class="text_content">
        <p><span><el-icon size="16" style="margin-right: 5px"><Warning/></el-icon></span>{{
            $t('batch.import.customer.tips')
          }}
        </p>
      </div>
    </div>
    <template #footer>
      <ElButton size="small" @click="close">
        {{ $t('common.cancel') }}
      </ElButton>
      <ElButton v-if="isShowData" type="primary" size="small" @click="close">
        {{ $t('common.close') }}
      </ElButton>
      <ElButton v-else size="small" type="primary" @click="addToEmails" :loading="loading">
        {{ $t('common.confirm') }}
      </ElButton>
    </template>

  </ElDialog>
  <ElDialog
      v-model="importDetailDialogVisible"
      :title="$t('customer.import.detail.title')"
      :width="1100"
      style="min-width: 760px"
      destroyOnClose
      :close-on-click-modal="false"
      :class="'headline import-detail-dialog'"
  >
    <el-table
        class="import-detail-table"
        :data="paginatedImportDetailList"
        style="width: 100%"
        :cell-style="importDetailCellStyle"
        :header-cell-style="importDetailHeaderCellStyle"
        max-height="480"
        @cell-mouse-leave="clearVisiblePopover"
    >
      <el-table-column :label="$t('customer.import.detail.serialNumber')" width="80" align="center">
        <template #default="{ $index }">
          {{ (importDetailPageNo - 1) * importDetailPageSize + $index + 1 }}
        </template>
      </el-table-column>

       <el-table-column prop="customerCode" :label="$t('common.customer.number')" min-width="120">
        <template #default="{ row }">
            {{row.customerCode}}
        </template>
      </el-table-column>
       <el-table-column prop="companyName" :label="$t('common.customer.name')" min-width="180">
        <template #default="{ row }">
          <div
              v-if="shouldShowImportDetailPopover(row.companyName, IMPORT_DETAIL_TEXT_LIMITS.companyName)"
              :ref="ref => (refMap[`${row.id}_company`] = ref)"
              @mouseover.stop="handleRef(refMap[`${row.id}_company`], row, 4)"
              class="import-detail-text"
              :key="row.companyName"
          >
            {{ formatText(row.companyName, IMPORT_DETAIL_TEXT_LIMITS.companyName) }}
          </div>
          <div v-else-if="row.companyName" class="import-detail-text">
            {{ row.companyName }}
          </div>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="zoneAddress" :label="$t('common.region.name')" min-width="80">
        <template #default="{ row }">
          <div style="cursor: pointer">
            <el-image :ref="ref => (refMap[`${row.id}_list_img`] = ref)"
                      @mouseover.stop="handleRef(refMap[`${row.id}_list_img`], row, 3)"
                      v-if="row?.zoneAddress"
                      :src="flag[row.zoneCode]"
                      style="width:26px;height:20px;margin-right:2px;vertical-align: middle;" :key="row.zoneCode"
                      lazy
            />
          </div> 
         <!-- {{row.zoneAddress}}-->
        </template>
      </el-table-column>
      <el-table-column
          prop="remark"
          :label="$t('customer.import.detail.failReason')"
          width="480"
      >
        <template #default="{ row }">
          <div v-if="row.remark" class="import-detail-fail-reason">
            {{ row.remark }}
          </div>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
      </template>
    </el-table>
    <div class="import-detail-pagination">
      <Pagination
          v-if="importDetailTotal"
          v-model:modelValue="importDetailPageNo"
          v-model:pageSizeValue="importDetailPageSize"
          :total="importDetailTotal"
          :is-show-select="false"
          :is-show-select-item="false"
          @change="handleImportDetailPageChange"
      />
    </div>
    <template #footer>
      <ElButton
          size="small"
          type="primary"
          @click="handleExportImportDetail"
          :loading="exportImportDetailLoading"
          :disabled="importDetailTotal === 0 || !importTaskId"
      >
        {{ $t('customer.import.detail.export') }}
      </ElButton>
      <ElButton size="small" @click="importDetailDialogVisible = false">
        {{ $t('common.close') }}
      </ElButton>
    </template>
  </ElDialog>

  <el-popover
      v-model:visible="visiblePopover"
      :virtual-ref="tempRef"
      virtual-triggering
      :width="'max-content'"
      trigger="hover"
      :popper-style="{ minWidth: '60px', width: 'auto' }"
      effect="dark"
      placement="right"
      :show-after="1200"
  >
    <template v-if="popoverType === 3">
      <div class="popover-content">{{ activeItemElpopover?.zoneAddress }}</div>
    </template>
    <template v-else-if="popoverType === 4">
      <div class="popover-content">{{ activeItemElpopover?.companyName }}</div>
    </template>
  </el-popover>
</template>

<script setup>
import {ElButton, ElDialog, ElEmpty, ElMessage} from "element-plus";
import {V2CreateTeam} from '../../api'
import {ref, defineProps, watch, defineEmits, reactive, computed, onMounted} from 'vue'
import {useStore} from "vuex";
import {i18n} from "@/lang";
import {
  exportFailCustomer,
  exportCustomerTemplate,
  getImportFailCustomerList,
  getImportCustomerData,
  getMailCustomerList,
  importCustomxerExcel,
  requestAllCustomer
} from "@/api/customer";
import TopSearch from "@/views/Customer/TopComponents/TopSearch.vue";
import Tables from "@/views/Customer/Tables/Tables.vue";
import {table_columns_list, table_columns_list_sp} from "@/views/Customer/map";
import {Download, Warning} from "@element-plus/icons-vue";
import Pagination from "@/components/Pagination/index.vue";
import {emailReg, emptyUrl, POPOVER_DELAY_TIME} from "@/utils/statusParams";
import flag from '@/assets/flag/index.js'
import {debouncePlus} from "@/utils/mylodash";
import {formatText, getTextLength} from "@/utils/util";

const store = useStore();
const emit = defineEmits(['close', 'getCustomerList', 'update:modelValue'])
const isShow = ref(false);
const teamName = ref("")
const loading = ref(false);
// 选中的数组
const checkList = ref([])

const {value, modelValue, isChecked} = defineProps({
  value: {type: Boolean, default: false},
  modelValue: {type: Boolean, default: false},
  isChecked: {type: Array, default: []}
})

watch(() => (modelValue ?? value), (val) => {
  isShow.value = val;
}, {immediate: true})

watch(isShow, (val) => {
  emit('update:modelValue', val)
})

const teamId = computed(() => store.state.email.teamID);
const isLoading = ref(false);


const showTargetEmails = ref([])
const customerList = ref([])
const percent = ref(0)
const fileList1 = ref([])
const fileTarget = ref(null)

async function handleUploadChange(file, fileList) {
  fileTarget.value = file
  console.log(file, fileTarget.value, 'ffff')
  if (fileList.length > 1) {
    fileList.splice(0, 1);
  }
  fileList1.value = fileList;
}

// 检测上传进度

function extractEmails(data) {
  return data.map(function (entry) {
    return entry["公司邮箱"];
  });
}

const readFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (e) => {
      resolve(e.target.result);
    };
    reader.onerror = (e) => {
      reject(e);
    };
  });
}

const IMPORT_PROGRESS_POLL_INTERVAL_MS = 3000
const IMPORT_PROGRESS_IDLE_TIMEOUT_MS = 3 * 60 * 1000
const IMPORT_PROGRESS_MAX_NO_CHANGE_COUNT = Math.ceil(IMPORT_PROGRESS_IDLE_TIMEOUT_MS / IMPORT_PROGRESS_POLL_INTERVAL_MS)

const isErrorExcel = ref(false)
//收集邮箱并添加
const addToEmails = async () => {
  console.log(fileTarget.value, 'file.value')
  if (!fileTarget.value) {
    ElMessage.warning(i18n.global.t('sys.tip.select.file'))
    return
  }
  const blob = new Blob([fileTarget.value.raw], {type: fileTarget.value.raw.type}); // 使用 file.row 而不是 file
  const formData = new FormData();
  formData.append('file', blob, fileTarget.value.name);
  formData.append('teamId', teamId.value);
  console.log(formData.get('file'), 'fff')
  loading.value = true;
  // 开始显示 进度条
  // 上传请求
  percent.value = 1
  try {
    const res = await importCustomxerExcel(formData, {
      headers: {'Content-Type': 'multipart/form-data'},
      // onUploadProgress: e => {
      //   // 上传进度
      //   const percentCompleted = Math.round((e.loaded * 100) / e.total);
      //   percent.value = percentCompleted;
      // }
    });

    const taskId = res?.result?.failId ?? '';
    importTaskId.value = res?.result?.["taskId:"] ?? ''
    importDetailRawList.value = []

    let timer = null;
    let lastTotalCount = 0;
    let lastSuccessFail = 0;
    let noChangeCount = 0;

    timer = setInterval(async () => {
      try {
        await getImportCustomerDataApis(taskId);

        const {totalCount = 0, successCount = 0, failCount = 0} = importCustomerMessage.value ?? {};
        const currentSuccessFail = successCount + failCount;

        console.log(importCustomerMessage.value, 'data');

        // 如果数据没有变化，计数
        if (totalCount === lastTotalCount && currentSuccessFail === lastSuccessFail) {
          noChangeCount++;
          if (noChangeCount >= IMPORT_PROGRESS_MAX_NO_CHANGE_COUNT) {
            console.warn('任务长时间无变化，停止轮询');
            percent.value = Math.min(percent.value, 100);
            clearInterval(timer);
            loading.value = false;
            isErrorExcel.value = true
            return;
          }
        } else {
          noChangeCount = 0;
        }
        isErrorExcel.value = false
        lastTotalCount = totalCount;
        lastSuccessFail = currentSuccessFail;

        // 计算目标百分比
        const targetPercent = totalCount > 0 ? Math.round((currentSuccessFail / totalCount) * 100) : 0;

        // 平滑增加 percent，不超过目标值
        if (percent.value < targetPercent) {
          console.log(targetPercent - percent.value, 'targetPercent - percent.value')
          // const step = Math.min(targetPercent - percent.value, 5); // 每次最多加 5%
          percent.value = targetPercent
        } else if (percent.value > targetPercent) {
          // 防止后端 totalCount 变化导致 percent 超过目标值
          percent.value = targetPercent;
        }

        // 任务完成
        if (totalCount > 0 && currentSuccessFail >= totalCount) {
          percent.value = 100;
          isShowData.value = true;
          clearInterval(timer);
          loading.value = false;
          console.log('任务完成');
        }

      } catch (err) {
        clearInterval(timer);
        loading.value = false
        console.error('轮询失败:', err);
      }
    }, IMPORT_PROGRESS_POLL_INTERVAL_MS);

  } catch (error) {
    loading.value = false;
    isShowData.value = true
    console.error('Error uploading file:', error);
  }

}

/**
 * excel 模版下载
 * @type {Ref<UnwrapRef<boolean>>}
 */
const downloadFile = ref(false);
const downloadExcel = async () => {
  await exportCustomerTemplate(_, {
    responseType: "blob",
    headers: {'Content-Type': 'application/vnd.ms-excel'}
  }).then(res => {
    const link = document.createElement('a');
    const blob = new Blob([res], {type: 'application/vnd.ms-excel;charset=utf-8'}); // 设置正确的字符编码
    link.style.display = 'none';
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', i18n.global.t('download.customer.template'));
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};

const cancel = () => {
  isShow.value = false
  emit("close");
  fileList1.value = [];
  fileTarget.value = null;
  importTaskId.value = ''
  importDetailRawList.value = []
  importDetailDialogVisible.value = false
}
const close = () => {
  cancel()
  if (isShowData.value) {
    emit("getCustomerList");
  }
}

const handleRemove = () => {
  console.log('closeFile')
  fileList1.value = [];
  fileTarget.value = null;
  percent.value = 0;
  isShowData.value = false
  importTaskId.value = ''
  importDetailRawList.value = []
  importDetailDialogVisible.value = false
}

const importCustomerMessage = ref({totalCount: 0, successCount: 0, failCount: 0})
const importTaskId = ref('')
const importDetailRawList = ref([])
const exportImportDetailLoading = ref(false)
const IMPORT_DETAIL_TEXT_LIMITS = {
  zoneAddress: 14,
  companyName: 18,
}
const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const handleRef = debouncePlus((targetRef, item, type) => {
  tempRef.value = targetRef
  popoverType.value = type
  activeItemElpopover.value = item
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)

const clearVisiblePopover = () => {
  visiblePopover.value = false
}

const shouldShowImportDetailPopover = (text, limit) => {
  return getTextLength(String(text || '')) > limit
}

const formattedMessage = computed(() => {
  const message = i18n.global.t('import.message.customer', {
    total: importCustomerMessage.value?.totalCount ?? 0,
    success: importCustomerMessage.value?.successCount ?? 0,
    failed: importCustomerMessage.value?.failCount ?? 0
  })
  return message
})

const isShowData = ref(false)
const importDetailDialogVisible = ref(false)
const importDetailPageNo = ref(1)
const importDetailPageSize = ref(10)

const IMPORT_DETAIL_LIST_KEYS = [
  'detailList',
  'details',
  'recordList',
  'records',
  'list',
  'items',
  'rows',
  'dataList',
  'importDetails',
  'failDetails'
]

const getImportDetailSourceList = (payload) => {
  if (Array.isArray(payload)) {
    return payload
  }

  if (!payload || typeof payload !== 'object') {
    return []
  }

  for (const key of IMPORT_DETAIL_LIST_KEYS) {
    if (Array.isArray(payload[key])) {
      return payload[key]
    }
  }

  return []
}

const formatImportDetailStatus = (row) => {
  const rawStatus = row?.statusText
    ?? row?.statusName
    ?? row?.resultStatusDesc
    ?? row?.resultStatus
    ?? row?.importStatusName
    ?? row?.importStatus
    ?? row?.status

  if (rawStatus === undefined || rawStatus === null || rawStatus === '') {
    return ''
  }

  if (typeof rawStatus === 'number') {
    if (rawStatus === 1) {
      return '成功'
    }
    if (rawStatus === 0 || rawStatus === 2 || rawStatus === -1) {
      return '错误'
    }
  }

  if (typeof rawStatus === 'boolean') {
    return rawStatus ? '成功' : '错误'
  }

  const normalizedStatus = String(rawStatus).trim().toLowerCase()
  if (['success', 'successful', 'succeed', 'ok', 'done', '成功'].includes(normalizedStatus)) {
    return '成功'
  }
  if (['fail', 'failed', 'error', 'wrong', '错误', '失败'].includes(normalizedStatus)) {
    return '错误'
  }

  return String(rawStatus)
}

const normalizeImportDetailZoneCode = (code) => {
  const normalizedCode = String(code ?? '').trim().toUpperCase()
  if (!normalizedCode) {
    return ''
  }

  const aliasMap = {
    UK: 'UK',
    GB: 'UK',
    EL: 'GR',
  }

  return aliasMap[normalizedCode] ?? normalizedCode
}

const getImportDetailFlagUrl = (row) => {
  const normalizedZoneCode = normalizeImportDetailZoneCode(
      row?.zoneCode ?? row?.countryCode ?? row?.areaCode ?? row?.zone
  )
  return flag[normalizedZoneCode] || ''
}

const importDetailList = computed(() => {
  return getImportDetailSourceList(importDetailRawList.value).map((item, index) => ({
    id: item?.id ?? item?.customerId ?? item?.mailCustomerId ?? index,
    zoneAddress: item?.zoneAddress,
    zoneCode: normalizeImportDetailZoneCode(item?.zoneCode ?? item?.countryCode ?? item?.areaCode ?? item?.zone),
    companyName: item?.companyName ?? item?.customerName ?? item?.company ?? item?.name ?? '',
    statusText: formatImportDetailStatus(item),
    remark: item?.remark ?? item?.errorMsg ?? item?.errorMessage ?? item?.message ?? item?.failReason ?? item?.reason ?? '',
    ...item,
  }))
})

const importDetailTotal = computed(() => importDetailList.value.length)
const paginatedImportDetailList = computed(() => {
  const start = (importDetailPageNo.value - 1) * importDetailPageSize.value
  const end = start + importDetailPageSize.value
  return importDetailList.value.slice(start, end)
})

const importDetailCellStyle = ({columnIndex}) => {
  const leftAlignedColumns = [1, 2, 4]
  return {
    textAlign: leftAlignedColumns.includes(columnIndex) ? 'left' : 'center',
    fontSize: '13px',
    color: '#303133',
    padding: '8px 0px'
  }
}

const importDetailHeaderCellStyle = ({columnIndex}) => {
  const leftAlignedColumns = [1, 2, 4]
  return {
    textAlign: leftAlignedColumns.includes(columnIndex) ? 'left' : 'center',
    background: '#f9f9f9',
    color: 'black',
    fontSize: '13px',
    fontWeight: 500,
    padding: '8px 0px'
  }
}

const handleImportDetailPageChange = ({pageNo, pageSize}) => {
  importDetailPageNo.value = pageNo
  importDetailPageSize.value = pageSize
}

const getImportFailCustomerListApis = async () => {
  if (!importTaskId.value) {
    importDetailRawList.value = []
    return
  }

  try {
    const payload = {id: importTaskId.value}
    const res = await getImportFailCustomerList(payload)
    importDetailRawList.value = res?.result ?? res?.data ?? []
  } catch (e) {
    importDetailRawList.value = []
  }
}

const openImportDetailDialog = async () => {
  importDetailPageNo.value = 1
  await getImportFailCustomerListApis()
  importDetailDialogVisible.value = true
}

const triggerBrowserDownload = (blob, fileName) => {
  const downloadUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = downloadUrl
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(downloadUrl)
}

const handleExportImportDetail = async () => {
  if (!importTaskId.value) {
    ElMessage.warning(i18n.global.t('customer.import.detail.export.noTaskId'))
    return
  }

  if (!importDetailList.value.length) {
    ElMessage.warning(i18n.global.t('customer.import.detail.export.emptyDetail'))
    return
  }

  exportImportDetailLoading.value = true

  try {
    const payload = {id: importTaskId.value}
    const res = await exportFailCustomer(payload, {
      responseType: 'blob'
    })
    const blob = res instanceof Blob ? res : new Blob([res], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })

    if (!blob.size) {
      ElMessage.warning(i18n.global.t('customer.import.detail.export.emptyFile'))
      return
    }

    triggerBrowserDownload(blob, `${i18n.global.t('customer.import.detail.export.fileNamePrefix')}_${Date.now()}.xlsx`)
  } catch (error) {
    console.error('Error exporting import detail:', error)
    ElMessage.error(i18n.global.t('customer.import.detail.export.failed'))
  } finally {
    exportImportDetailLoading.value = false
  }
}

const getImportCustomerDataApis = async (id) => {
  try {
    const payload = {id: id}
    const res = await getImportCustomerData(payload)
    console.log(res, 'dddddd')
    importCustomerMessage.value = res.result;
  } catch (e) {

  }
}
</script>

<style scoped lang="less">
@import "../../less/page.less";

.fx-j-c {
  display: flex;
  justify-content: center;
}

.settings {
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
}

:deep(.el-progress__text) {
  display: none;
}

:deep(.el-upload-list) {
  line-height: 50px;
  width: 250px;
  transform: translateX(-50%);
}

:deep(.el-upload-list__item) {
  left: 50%;
}

:deep(.el-upload-list__item-info) {
  align-items: center !important;
}

:deep(.el-upload-list__item-file-name) {
  font-size: 14px;
  font-weight: 600;
  max-width: 200px !important;
}

:deep(.text_content) {

  & > p {
    line-height: 20px;
    font-weight: 500;
    color: #dca550;
    display: flex;
    align-items: flex-start;
    margin-bottom: 6px;
    justify-content: center;

    & > span {
      padding-top: 2px;
    }

  }
}

.headline > .el-dialog__header {
  border-bottom: 1px solid #eee !important;
}


.headline > .el-dialog__footer {
  border-top: 1px solid #eee !important;
}

.import_message {
  width: 100%;
  padding: 0px 60px;
  text-align: center;
  margin: 20px auto;
  color: #439eff;
}

.import-detail-btn {
  margin-left: 8px;
  vertical-align: baseline;
  font-size:14px !important;
}

.import-detail-pagination {
  margin-top: 16px;
}

.import-detail-zone {
  display: inline-flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  min-width: 0;
}

.import-detail-flag {
  width: 26px;
  height: 20px;
  margin-right: 6px;
  flex-shrink: 0;
  vertical-align: middle;
}

.import-detail-text {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.import-detail-text-danger {
  color: red;
}

.import-detail-fail-reason {
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

:deep(.import-detail-table .el-table__cell) {
  font-size: 13px;
  vertical-align: middle;
}

:deep(.import-detail-table td.el-table__cell > .cell) {
  display: flex;
  align-items: center;
  min-height: 100%;
}

:deep(.import-detail-table th.el-table__cell > .cell) {
  font-size: 13px;
  font-weight: 500;
}

:deep(.import-detail-table .el-table__inner-wrapper::before) {
  content: none !important;
  display: none !important;
}

:deep(.import-detail-pagination .page_box) {
  justify-content: flex-end;
}

:deep(.import-detail-pagination .left_total) {
  margin-right: auto;
}

:deep(.import-detail-pagination .right_setting) {
  margin-top: 16px;
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-empty__description) {
  margin-top: 10px;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
